export default "__VITE_ASSET__uESPBtqr__"